import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {ActionUsersState} from './types';
import {getters} from './getters';
import {actions} from './actions';
import {mutations} from './mutations';

export const state: ActionUsersState = {
  actionUsers: [],
  objectTypes:[],
  partnerUsersPages:[],
};

export const actionUsers: Module<ActionUsersState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
